import { JobAddressSelection } from "../../Jobbing/models/JobAddressSelection";
import UploadAttachment from "../../Jobbing/models/UploadAttachment";
import { JobTypeEnum } from "../enum/JobTypeEnum";
import { ContainerJobContact } from "./ContainerJobContact";
import { CreateContainerJobRequestItem } from "./CreateContainerJobRequestItem";
import { CreateContainerJobRequestPortData } from "./CreateContainerJobRequestPortData";

export class CreateContainerJobRequest {
    public clienteleId: number = 0;
    public tswId: string | null = null;
    public ecn: string | null = null;
    public jobTypeCode: JobTypeEnum = JobTypeEnum.Undefined;
    public intermodalDivisionId: number = 0;
    public divisionId: number = 0;
    public billingDivisionId: number = 0;
    public firstNotifiedDate: Date | null = null;
    public documentsReceivedDate: Date | null = null;
    public documentsReceivedLate: boolean = false;
    public fromAddress: JobAddressSelection | null = null;
    public fromJobContact: ContainerJobContact | null = null;
    public toAddress: JobAddressSelection | null = null;
    public toJobContact: ContainerJobContact | null = null;
    public portData: CreateContainerJobRequestPortData | null = null;
    public intermodalPortData: CreateContainerJobRequestPortData | null = null;
    public containers: CreateContainerJobRequestItem[] = [];
    public attachments: UploadAttachment[] = [];
    public bacc: UploadAttachment[] = [];
}
